
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import PageLoadingSpinner from '@/components/common/PageLoadingSpinner';
import {
  LazyProfile,
  LazyProfileAdmin,
  LazyProfileManager
} from './lazyRoutes';

const withSuspense = (
  Component: React.LazyExoticComponent<React.ComponentType<Record<string, never>>>,
  fallbackMessage?: string
) => {
  return (
    <Suspense fallback={<PageLoadingSpinner message={fallbackMessage} />}>
      <Component />
    </Suspense>
  );
};

export const getProfileRoutes = (): JSX.Element[] => [
  <Route key="profile" path="/profile" element={
    <ProtectedRoute>
      {withSuspense(LazyProfile, "Загрузка профиля...")}
    </ProtectedRoute>
  } />,
  <Route key="profile-admin" path="/profile-admin" element={
    <ProtectedRoute>
      {withSuspense(LazyProfileAdmin, "Загрузка админ-профиля...")}
    </ProtectedRoute>
  } />,
  <Route key="profile-manager" path="/profile-manager" element={
    <ProtectedRoute>
      {withSuspense(LazyProfileManager, "Загрузка профиля менеджера...")}
    </ProtectedRoute>
  } />,
];
